import { dataTransform } from '@nexio/emvio-util-app';
import React, { Component } from 'react';
import {
    getAdjustments as fetchAdjustments,
    fetchUrl
} from './adjustmentsActions';
import {
    getAdjustments,
    getCount,
    getPages,
    getAdjustmentsErrorMessage,
    getIsAdjustmentsLoading
} from './adjustmentsEntity';
import AdjustmentsListItem from './AdjustmentsListItem/AdjustmentsListItem';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import AmountFilter from '../Table/Filters/AmountFilter/AmountFilter';
import { transformDateCell } from '../../utils/cell';
import Table from '../Table/Table';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import InPageMerchantSelector from '../MerchantSelector/InPageMerchantSelector';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getSelf } from '../Self/selfEntity';

export const defaultColumnsAndProps = [
    {
        accessor: 'merchantName',
        filterable: false,
        label: 'Merchant',
        minWidth: 150,
        show: true,
        sortable: false
    },
    {
        accessor: 'reportDate',
        Cell: transformDateCell,
        transformData: dataTransform.dateTimezoneButHideTimezone,
        transformType: 'dateTimezoneButHideTimezone',
        defaultSortDesc: true,
        filterable: false,
        label: 'Report Date',
        minWidth: 130,
        show: true
    },
    {
        accessor: 'netAmount',
        Cell: (props) => <ColorDollarAmountCell amount={props.value}/>,
        className: ['right-justify'],
        Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
        label: 'Amount',
        minWidth: 120,
        show: true
    },
    {
        accessor: 'lockBoxBatch',
        label: 'Descriptor',
        minWidth: 105,
        show: true
    },
    {
        accessor: 'merchantId',
        excelStringField: true,
        filterable: false,
        label: 'Merchant ID',
        minWidth: 145,
        show: false
    }
];

export class Adjustments extends Component {
    render() {
        const dateKey = 'reportDate';

        return (
            <>
                {this.props.flags?.resellerPhase1 && this.props.self?.accountType === 'RESELLER' && <InPageMerchantSelector />}
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-adjustments-table"
                    dateKey={dateKey}
                    defaultColumnsAndProps={defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: dateKey
                    }]}
                    fetchData={fetchAdjustments}
                    countSelector={getCount}
                    dataSelector={getAdjustments}
                    errorMessageSelector={getAdjustmentsErrorMessage}
                    isDataLoadingSelector={getIsAdjustmentsLoading}
                    pagesSelector={getPages}
                    itemKey=""
                    hasNoCount={true}
                    ListItemComponent={AdjustmentsListItem}
                    noDataText="No Adjustments Found"
                    shouldUseGlobalDate
                    uniqueTableName="Adjustments"
                    filterable={true}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        self: getSelf(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Adjustments)));